import _ from 'lodash';
export const compareObjects = (object1: any, object2: any) => {
    const keys1 = Object.keys(object1);
    const keys2 = Object.keys(object2);

    if (keys1.length !== keys2.length) {
        return false;
    }

    for (let key of keys1) {
        if (!_.isEqual(object1[key], object2[key])) {
            return false;
        }
    }

    return true;
}